<template>
  <AgGridRenderList
    class="personnel-grid-lines"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../Mixins/general";

export default {
  components: {},
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    callGroupDelete: {
      type: Boolean,
      default: false,
    },
    callDelete: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIds: [],
      rowObject: null,
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      paginationLoading: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        maxWidth: 50,
        minWidth: 50,
        cellRenderer: "AgVMenu",
        cellRendererParams: (params) => ({
          items: [
            {
              label: this.$t("edit"),
              icon: "mdi-pencil",
              iconColor: "gray",
              action: (rowData) => this.editAction(rowData),
            },
            {
              label: this.$t("commandments"),
              icon: "mdi-file-document",
              iconColor: "gray",
              action: (rowData) => this.goToCommandment(rowData),
            },
            {
              label: this.$t("delete"),
              icon: "mdi-trash-can-outline",
              iconColor: "gray",
              action: (rowData) => this.deleteActionPermission(rowData),
            },
          ],
        }),
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 70,
        maxWidth: 70,
        minWidth: 70,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("gender"),
        field: "gender",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.user.gender) {
            return this.$t(`${params.data.user.gender}`);
          }
        },
        sortable: true,
        minWidth: 80,
        maxWidth: 80,
      },
      {
        headerName: this.$t("name_and_lastName"),
        field: "product.name",
        // filter: "agTextColumnFilter",
        valueGetter: (params) => {
          const user = params.data?.user;
          if (!user) return this.$t("haveNot");
          const firstname = user.firstname?.trim();
          const lastname = user.lastname?.trim();
          if (firstname && lastname) {
            return `${firstname} ${lastname}`;
          }
          if (firstname) {
            return firstname;
          }
          if (lastname) {
            return lastname;
          }
          return this.$t("haveNot");
        },
        minWidth: 360,
        maxWidth: 460,
        sortable: true,
      },
      {
        headerName: this.$t("personnelCode"),
        field: "personnel_code",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.personnel_code) {
            return "#" + params.data.personnel_code;
          } else {
            return this.$t("haveNot");
          }
        },
        width: 220,
        maxWidth: 220,
        minWidth: 220,
        sortable: true,
      },
      {
        headerName: this.$t("national-code"),
        field: "national_code",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.user && params.data.user.national_code) {
            return params.data.user.national_code;
          } else {
            return this.$t("haveNot");
          }
        },
        sortable: true,
        width: 220,
        maxWidth: 220,
        minWidth: 220,
      },
      {
        headerName: this.$t("workshop"),
        field: "workshop",
        // filter: "agNumberColumnFilter",
        valueGetter: (params) => {
          if (params.data && params.data.workshop.name) {
            return params.data.workshop.name;
          } else {
            return 0;
          }
        },
        sortable: true,
        width: 280,
        maxWidth: 280,
        minWidth: 280,
      },
    ];
  },
  computed: {},
  watch: {
    callGroupDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deletegroupAction();
        }
      },
    },
    callDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deleteAction();
        }
      },
    },
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onSelectionChanged(rows) {
      const ids = rows.map((r) => r.id);
      if (ids.length > 1) {
        this.selectedIds = ids;
        this.$emit("group-delete", true);
        return;
      }
      this.selectedIds = [];
      this.$emit("group-delete", false);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "employee", {
          params: {
            options: app.optionsNew,
          },
        })
        .then((response) => {
          app.rowData = [...response.data.data];
          app.totalRows = response.data.total;
          app.lastPage = response.data.last_page;
          app.$emit("workshop-items", {
            items: response.data,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    editAction(rowData) {
      this.$router.push({ name: "customerEdit", params: { id: rowData.user_id } });
    },
    goToCommandment(rowData) {
      this.$router.push({ name: "commandments_By_id", params: { id: rowData.id } });
    },
    deleteActionPermission(rowData) {
      this.$emit("open-dialog-permision", true);
      this.rowObject = rowData;
    },
    deleteAction() {
      var app = this;
      if (!app.rowObject?.id) {
        app.$emit("close-dialog-permision");
        return;
      }
      app.$axios
        .delete(app.$endpoint + "employee/" + app.rowObject.id)
        .then(() => {
          app.$emit("close-dialog-permision");
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("close-dialog-permision");
          app.getItems(true);
          app.paginationLoading = false;
        });
    },
    deletegroupAction() {
      var app = this;
      let ids = app.selectedIds;
      app.$axios
        .delete(app.$endpoint + "employee/0", {
          params: { deleteItems: ids },
        })
        .then(() => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
        })
        .catch((err) => {
          app.$emit("close-dialog-permision");
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
          app.paginationLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}

/* .personnel-grid-lines ::v-deep .ag-header-cell,
.personnel-grid-lines ::v-deep .ag-cell {
  border-left: 1.2px solid rgb(188, 188, 188) !important;
}

.personnel-grid-lines ::v-deep .ag-header-row,
.personnel-grid-lines ::v-deep .ag-row {
  border-bottom: 1px solid #e0e0e0 !important;
}

.personnel-grid-lines ::v-deep .ag-header-cell:last-child,
.personnel-grid-lines ::v-deep .ag-cell:last-child {
  border-left: none !important;
} */
</style>
